var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "mobileEntranceAd" } }, [
    _c("ins", {
      staticClass: "kakao_ad_area",
      staticStyle: { display: "none", width: "100%", "vertical-align": "top" },
      attrs: {
        "data-ad-unit": _vm.adUnit,
        "data-ad-media": "320",
        "data-ad-pubuser": "1v8",
        "data-ad-type": "A",
        "data-ad-width": "320",
        "data-ad-height": "100",
        "data-ad-param-cp": _vm.grpid,
        "data-ad-param-channel": "cafe"
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }